<template>
    <div>
        <div class="service-fixed" @click="serviceShow"></div>
        <serviceDialog ref="serviceDialog"
                       imgSrc="https://assets.pfotoo.com/images/version/qrcode-qy-0412.png"></serviceDialog>
    </div>
</template>
<script>
  import serviceDialog from './service-dialog.vue'
  export default {
    props:{

    },
    data () {
      return {

      }
    },
    components:{
      serviceDialog,
    },
    methods:{
      serviceShow(){
        this.$refs.serviceDialog.show()
      },
    },
    created(){

    },
  }
</script>
<style>
    .service-fixed{
        background-image: url("https://assets.pfotoo.com/images/version/service-man.png");
        background-size: 100% 100%;
        width: 62px;
        height: 62px;
        position: fixed;
        right:10px;
        bottom: 120px;
        z-index: 1;
    }
</style>


// WEBPACK FOOTER //
// src/components/service-fixed.vue